// extracted by mini-css-extract-plugin
module.exports = {"container":"_6f2f052"};